import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiUrl } from '@brand-lolly/app/_services/base-api-urls';
import { Observable } from 'rxjs';
import { ProductId } from '@brand-lolly/app/billing/types/product.types';
import { UncancelResponse } from '@brand-lolly/app/billing/types/mutations.types';
import { idempotencyHeaders } from './idempotency.util';

export interface IUncancelSubscriptionService {
	uncancel(productId: ProductId): Observable<UncancelResponse>;
}

@Injectable({ providedIn: 'root' })
export class UncancelSubscriptionService
	implements IUncancelSubscriptionService
{
	private readonly url = `${BaseApiUrl.SocialMessengerPython}billing/uncancel`;

	constructor(private http: HttpClient) {}

	uncancel(productId: ProductId): Observable<UncancelResponse> {
		const params = new HttpParams().set('product_id', String(productId));
		return this.http.post<UncancelResponse>(
			this.url,
			{},
			{
				headers: idempotencyHeaders(),
				params
			}
		);
	}
}
